export const NDP_2026_TAG = "ndp-2026";
export const NDP_2026_TAGNAME = "தேசிய தினம் 2026";
export const NDR_2026_TAGNAME = "தேசிய தினப் பேரணி உரை 2026";
